// extracted by mini-css-extract-plugin
export default {"search":"Faq_search__EU6Yl","tableRoot":"Faq_tableRoot__j5zj6"};